































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'
import { User } from '@/api/model/user'
import { Company } from '@/api/model/company'

@Component
export default class InputTextarea extends Vue {
    @Ref() element!: HTMLTextAreaElement
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: true }) readonly autoSize!: boolean
    @Prop({ type: Boolean, default: false }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop({ default: '2' }) readonly rows!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    @Prop({ required: true }) readonly users!: User[]
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
        this.internalValue = this.transformInput(this.value)
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        if (typeof value === 'string') {
            value = value.replaceAll('<br>', '\n')
        }

        if (!value) {
            return null
        }

        // map one to legacy
        this.users.forEach(user => {
            let oneString = '<span class="mention" data-denotation-char="@" data-id="##USER_ID##" data-type="user" data-value="##USER_NAME##">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="keyvue-mention">##USER_NAME##</span></span>﻿</span>'
            oneString = oneString.replaceAll('##USER_ID##', user.id)
            oneString = oneString.replaceAll('##USER_NAME##', user.name)

            value = value.replaceAll(oneString, `@${user.name}`)

            // we try it with another version because input and migration sometimes have different outcomes
            oneString = '<span class="mention" data-denotation-char="@" data-id="##USER_ID##" data-type="user" data-value="##USER_NAME##">﻿<span contenteditable="false">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="keyvue-mention">##USER_NAME##</span></span>﻿</span>﻿</span>'
            oneString = oneString.replaceAll('##USER_ID##', user.id)
            oneString = oneString.replaceAll('##USER_NAME##', user.name)

            value = value.replaceAll(oneString, `@${user.name}`)
        })

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        if (typeof value === 'string') {
            value = value.replaceAll('\n', '<br>')
        }

        if (!value) {
            return null
        }

        // map legacy to one
        this.users.forEach(user => {
            let oneString = '<span class="mention" data-denotation-char="@" data-id="##USER_ID##" data-type="user" data-value="##USER_NAME##">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@</span><span class="keyvue-mention">##USER_NAME##</span></span>﻿</span>'
            oneString = oneString.replaceAll('##USER_ID##', user.id)
            oneString = oneString.replaceAll('##USER_NAME##', user.name)

            value = value.replaceAll(`@${user.name}`, oneString)
        })

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.autoSize) {
            const offset = this.element.offsetHeight - this.element.clientHeight
            this.element.style.height = 'auto'
            this.element.style.height = `${this.element.scrollHeight + offset}px`
        }

        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get componentClass(): object {
        return {
            'input-textarea': true,
            'input-textarea--focussed': this.focus,
            'input-textarea--disabled': this.disabled,
            'bd-round-outline': true,
        }
    }

    get mentionableItems(): Array<{ label: string, value: any, user: User }> {
        return this.users.map(user => ({
            label: user.name,
            value: user.name,
            user,
        }))
    }

    isCurrentCompany(company: Company): boolean {
        return this.$currentCompany.id === company.id
    }
}
